import React, {useEffect, useState} from 'react';
import {faker} from '@faker-js/faker';
import {useParams} from 'react-router-dom';
//#region MUI
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import EventIcon from '@mui/icons-material/Event';
import BugReportIcon from '@mui/icons-material/BugReport';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import Typography from '@mui/material/Typography';
import {SelectBase, hooks} from 'lib.front';
//#endregion
function bulletpointGenerator(number) {
   const data = [];
   for (let inx = 0; inx < number; inx++) {
      const bulletpoint = {texto: faker.lorem.paragraph(), img: []};
      if (existeArreglo(3)) {
         const links = fakerRandom(1, 3);
         for (let inxImg = 0; inxImg < links; inxImg++) {
            bulletpoint.img.push(faker.image.url());
         }
      }
      data.push(bulletpoint);
   }
   return data;
}
function existeArreglo(max = 2) {
   return fakerRandom(0, max) > 0;
}
function fakerRandom(min, max) {
   return faker.number.int({min, max});
}
function dataGenerator(number, product) {
   const data = [];
   for (let inx = 0; inx < number; inx++) {
      const element = {
         producto: product,
         fecha: faker.date
            .between({from: new Date(2020, 0, 1), to: new Date(2099, 11, 31)})
            .toISOString(),
         version: faker.string.uuid(),
         denominacion: fakerRandom(0, 3) > 0 ? '' : faker.animal.type(),
         bugs: existeArreglo(3) ? bulletpointGenerator(fakerRandom(1, 5)) : [],
         mejoras: existeArreglo(3) ? bulletpointGenerator(fakerRandom(1, 5)) : [],
         nuevo: existeArreglo(3) ? bulletpointGenerator(fakerRandom(1, 5)) : []
      };
      data.push(element);
   }
   return data;
}
const datagen = [
   ...dataGenerator(3, 'crm'),
   ...dataGenerator(4, 'key'),
   ...dataGenerator(2, 'dscloud')
];
const SECCION_NUEVO = 'nuevo';
const SECCION_BUGS = 'bugs';
const SECCION_MODIFICADO = 'modificado';
const LABEL_CARGANDO = 'Cargando...';
const LABEL_ERROR = 'Error!!!';
function PatchNotes() {
   const [data, setdata] = useState([]);
   const {producto} = useParams();
   const [] = hooks.usefet;
   useEffect(() => {
      if (producto) {
         const dataAux = datagen.filter(item => item.producto === producto);
         setdata(dataAux);
         setversiones(
            dataAux.map(item => ({value: item.version, label: item.version.substring(0, 5)}))
         );
      }
   }, [producto]);

   const [versiones, setversiones] = useState([]);

   const [selectedVersion, setselectedVersion] = useState(null);
   function handleSelectedVersionChange(newValue) {
      setselectedVersion(newValue);
   }
   const [selectedVersionData, setselectedVersionData] = useState(null);
   const [setseccionesVisibles, setsetseccionesVisibles] = useState([]);
   useEffect(() => {
      if (selectedVersion && selectedVersion.value) {
         const versionData = data.find(item => item.version === selectedVersion.value);
         setselectedVersionData(versionData);
         const nuevasSeccionesVisibles = [];
         if (versionData[SECCION_NUEVO] && versionData[SECCION_NUEVO].length > 0) {
            nuevasSeccionesVisibles.push(SECCION_NUEVO);
         }
         if (versionData[SECCION_MODIFICADO] && versionData[SECCION_MODIFICADO].length > 0) {
            nuevasSeccionesVisibles.push(SECCION_MODIFICADO);
         }
         if (versionData[SECCION_BUGS] && versionData[SECCION_BUGS].length > 0) {
            nuevasSeccionesVisibles.push(SECCION_BUGS);
         }
      }
   }, [selectedVersion]);

   const [selectedSeccion, setSelectedSection] = React.useState(1);
   const handleListItemClick = (event, index) => {
      setSelectedSection(index);
   };
   return (
      <Container>
         <Grid container>
            <Grid container item xs={12} justifyContent="center">
               <Typography variant="h1" align="center">
                  {producto ? producto.toUpperCase() : 'Producto no existe'}
               </Typography>
            </Grid>
            <Grid container item xs={4}>
               <List component="nav">
                  <ListItem>
                     <div style={{width: '100%'}}>
                        <SelectBase
                           label="Versiones"
                           options={versiones}
                           value={selectedVersion}
                           onChange={handleSelectedVersionChange}
                           margin="dense"
                           variant="outlined"
                        />
                     </div>
                  </ListItem>
                  <ListItem>
                     <ListItemIcon>
                        <EventIcon />
                     </ListItemIcon>
                     <ListItemText primary={selectedVersionData && selectedVersionData.fecha} />
                  </ListItem>
                  <ListItem
                     button
                     selected={selectedSeccion === SECCION_NUEVO}
                     onClick={event => handleListItemClick(event, SECCION_NUEVO)}
                  >
                     <ListItemIcon>
                        <FiberNewIcon />
                     </ListItemIcon>
                     <ListItemText primary={SECCION_NUEVO} />
                  </ListItem>
                  <ListItem
                     button
                     selected={selectedSeccion === SECCION_MODIFICADO}
                     onClick={event => handleListItemClick(event, SECCION_MODIFICADO)}
                  >
                     <ListItemIcon>
                        <NewReleasesIcon />
                     </ListItemIcon>
                     <ListItemText primary={SECCION_MODIFICADO} />
                  </ListItem>
                  <ListItem
                     button
                     selected={selectedSeccion === SECCION_BUGS}
                     onClick={event => handleListItemClick(event, SECCION_BUGS)}
                  >
                     <ListItemIcon>
                        <BugReportIcon />
                     </ListItemIcon>
                     <ListItemText primary={SECCION_BUGS} />
                  </ListItem>
               </List>
            </Grid>
            <Grid container item xs={8}>
               <Grid container item xs={12}></Grid>
            </Grid>
         </Grid>
         <div>{JSON.stringify(producto)}</div>
         <div>{JSON.stringify(data)}</div>
      </Container>
   );
}

export default PatchNotes;
